import { EventSession } from 'modules/calendar/core/type';

import { create } from 'zustand';

interface EventState {
  events: EventSession[];
  setEvents: (events: EventSession[]) => void;
}

const useEventStore = create<EventState>()((set) => ({
  events: [],
  setEvents: (events) => set({ events }),
}));

export default useEventStore;
